import _isEmpty from "lodash/isEmpty";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { ValidationField } from "../../../../models";

const initialState = (): ValidationField => ({
    errors: {},
    values: {},
    visible: {},
    started: {},
});

const inputHelper = (state: ValidationField = {}, inputName: string, inputValue: boolean) => {
    const inputParts = inputName.split("-");
    if (inputParts[1]) {
        return {
            ...state,
            [inputParts[0]]: {
                ...state[inputParts[0]],
                [inputParts[1]]: inputValue,
            },
        };
    } else {
        return {
            ...state,
            [inputParts[0]]: inputValue,
        };
    }
};

const removeProperty = (propertyName: string, fromObject: ValidationField = {}) => {
    if (_isEmpty(fromObject)) {
        return {};
    }

    const propertyNameParts = propertyName.split("-");
    if (propertyNameParts[1]) {
        const toObject = Object.assign({}, fromObject);

        if (!toObject[propertyNameParts[0]]) {
            return fromObject;
        }

        toObject[propertyNameParts[0]] = { ...toObject[propertyNameParts[0]] };
        delete toObject[propertyNameParts[0]][propertyNameParts[1]];
        return toObject;
    } else {
        const toObject = Object.assign({}, fromObject);
        delete toObject[propertyName];
        return toObject;
    }
};

const createReducer = (formId: string) => {
    return (state = initialState(), action: AnyAction) => {
        if (action.type === AT.FORM_VALUE_CHANGED(formId)) {
            const { errorMessage, inputName, inputValue, visible, started } = action.payload;
            return {
                ...state,
                errors: inputHelper(state.errors, inputName, errorMessage),
                values: inputHelper(state.values, inputName, inputValue),
                visible: inputHelper(state.visible, inputName, visible),
                started: inputHelper(state.started, inputName, started),
            };
        } else if (action.type === AT.FORM_REMOVE_INPUT(formId)) {
            return {
                ...state,
                errors: removeProperty(action.payload.inputName, state.errors),
                // values: removeProperty(action.payload.inputName, state.values),
                visible: inputHelper(state.visible, action.payload.inputName, false),
                started: inputHelper(state.visible, action.payload.inputName, false),
            };
        } else if (action.type === AT.FORM_REMOVE_FIELD(formId)) {
            return {
                ...state,
                errors: removeProperty(action.payload.inputName, state.errors),
                visible: removeProperty(action.payload.inputName, state.visible),
                started: removeProperty(action.payload.inputName, state.started),
                values: removeProperty(action.payload.inputName, state.values),
            };
        } else if (action.type === AT.FORM_VALIDATE_ALL(formId)) {
            return {
                ...state,
                errors: action.payload.errors,
            };
        } else if (action.type === AT.FORM_CLEAR_ALL(formId)) {
            return initialState();
        } else {
            return state;
        }
    };
};

export default createReducer;
